import { createContext } from 'react';
export const modalContext = /*#__PURE__*/createContext({
  inModal: false,
  actions: [],
  setActions: () => void 0
});